import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tpl-header" }

import { ref, onMounted, computed } from 'vue'
import { GD, STORE_NAME, Storage, User } from '@gd/storage'
import Accountbox from '@gd/accountbox'
import { GdNavigationTabs, GdHeader } from '@gd/classic-template'
import events from '@gd/event-bus'

/**
 * * theme: winter
 * * selectedTab: home, games, myGameduell, community, infoAndHelp
 * * headerBlank: initializes the header with blank style ( like for the games ) or standard
 * * blackRibbon: activate the black ribbon
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
    selectedTab: { default: '' },
    theme: { default: '' },
    headerBlank: { type: Boolean, default: false },
    blackRibbon: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const headerBlankRef = ref(props.headerBlank)
const selectedTabRef = ref(props.selectedTab)
const header = ref(true)
const storageGd: GD = new Storage().read(STORE_NAME.GD)
const storageUser: User = new Storage().read(STORE_NAME.USER)

onMounted(() => {
  events.$on('template', (obj: { headerBlank: boolean; footerBlank: boolean; header: boolean; footer: boolean }) => {
    if (Object.prototype.hasOwnProperty.call(obj, 'headerBlank')) {
      headerBlankRef.value = obj.headerBlank
    }

    if (Object.prototype.hasOwnProperty.call(obj, 'header')) {
      header.value = obj.header
    }
  })
})

function onLink(tabName, event) {
  navTab.value = tabName
  // prevent bubbling to avoid href execution (href on link is only for mouse middle click to open in new tab)
  event.preventDefault()
}

const navTab = computed({
  get() {
    return selectedTabRef.value
  },
  set(name: string) {
    selectedTabRef.value = name
    let url = ''
    switch (name) {
      case 'home':
        url = '/gd/homepage/home.xhtml'
        break
      case 'games':
        url = '/gd/gamesPage/gamespage.xhtml'
        break
      case 'community':
        url = '/gd/playerProfile/showProfile.xhtml'
        break
      case 'myGameduell':
        url = '/gd/myGameDuell/playerInfo.xhtml'
        break
      case 'infoAndHelp':
        url = '/gd/help/help.xhtml'
        break
    }
    location.href = url || '#'
  },
})

function accountboxNavigationHandler(nav: { url: string; button: number; type: string }) {
  // LOPS-6861 disable tracking
  if (nav.button === 1) {
    window.open(nav.url, undefined, 'noopener')
  } else {
    location.href = nav.url
  }
}

function accountboxNavigationPaymentHandler() {
  // LOPS-6861 disable tracking
  events.$emit('deposit', { trackingId: 'accountbox' })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      duration: { enter: 0, leave: 500 }
    }, {
      default: _withCtx(() => [
        (header.value)
          ? (_openBlock(), _createBlock(_unref(GdHeader), {
              key: 0,
              theme: _ctx.theme,
              "header-blank": !headerBlankRef.value,
              partner: _unref(storageGd).partner,
              "black-ribbon": _ctx.blackRibbon
            }, {
              accountbox: _withCtx(() => [
                _createVNode(_unref(Accountbox), {
                  onOnShowProfile: accountboxNavigationHandler,
                  onOnShowFriends: accountboxNavigationHandler,
                  onOnShowMessages: accountboxNavigationHandler,
                  onOnShowChallanges: accountboxNavigationHandler,
                  onOnPayment: accountboxNavigationPaymentHandler,
                  onOnLoyality: accountboxNavigationHandler,
                  "force-load-data": false,
                  class: "accountbox-wrap base dsari"
                })
              ]),
              "navigation-tabs": _withCtx(() => [
                _createVNode(_unref(GdNavigationTabs), {
                  loyalty: _unref(storageUser).loyalty,
                  tab: navTab.value,
                  onLink: onLink
                }, null, 8, ["loyalty", "tab"])
              ]),
              _: 1
            }, 8, ["theme", "header-blank", "partner", "black-ribbon"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})